<template>
  <f7-page name="home" :page-content="false">
    <!-- Top Navbar -->
    <f7-navbar :sliding="false">
      <f7-nav-title sliding>Panel de control</f7-nav-title>
      <f7-nav-right>
        <f7-link 
          icon-f7="wand_stars" class="pointer" 
          v-tooltip="'Limpiar datos sincronizados'" 
          @click="limpiarDatos()"
        ></f7-link>
        <f7-link 
          icon-f7="arrow_down_doc" class="pointer" 
          v-tooltip="'Descargar Expediente'" 
          @click="descargarExpediente()"
        ></f7-link>
      </f7-nav-right>
    </f7-navbar>
    <!-- Page content-->
    <f7-page-content class="full-height">
      <f7-row class="width-100" style="max-width:800px;margin:auto;">
        <template v-if="isSync()">
          <a class="col-100 medium-50" href="/inspecciones-offline/">
            <f7-card class="card-button">
              <f7-card-content>
                <f7-icon f7="doc_fill"></f7-icon>
                <f7-icon f7="plus" style="color:white; font-size:42px; bottom:0px; right: 70px;"></f7-icon>
              </f7-card-content>
              <f7-card-footer class="bg-color-primary text-color-white">Nuevo expediente</f7-card-footer>
            </f7-card>
          </a>
          <a class="col-100 medium-50" href="/inspecciones-offline-anteriores/">
            <f7-card class="card-button">
              <f7-card-content>
                <f7-icon f7="doc_text_search_fill"></f7-icon>
              </f7-card-content>
              <f7-card-footer class="bg-color-primary text-color-white">Expedientes anteriores</f7-card-footer>
            </f7-card>
          </a>
          <!-- <a class="col-100 medium-50" href="/albaranes-offline/">
            <f7-card class="card-button">
              <f7-card-content>
                <f7-icon f7="doc"></f7-icon>
                <f7-icon f7="signature" style="font-size:50px; bottom:10px; right: 50px;"></f7-icon>
              </f7-card-content>
              <f7-card-footer class="bg-color-primary text-color-white">Albaranes</f7-card-footer>
            </f7-card>
          </a> -->
        </template>
        <a class="col-100 medium-50" @click="sync()">
          <f7-card class="card-button">
            <f7-card-content>
              <f7-icon f7="cloud_download"></f7-icon>
            </f7-card-content>
            <f7-card-footer class="bg-color-primary text-color-white">Sincronizar</f7-card-footer>
          </f7-card>
        </a>
        <a class="col-100 medium-50" href="/calendario/">
          <f7-card class="card-button">
            <f7-card-content>
              <f7-icon f7="calendar"></f7-icon>
            </f7-card-content>
            <f7-card-footer class="bg-color-primary text-color-white">Calendario</f7-card-footer>
          </f7-card>
        </a>
        <!-- Gastos: como el calendario, va contra el servidor y no necesita sincronizar nada. -->
        <a class="col-100 medium-50" href="/gastos/">
          <f7-card class="card-button">
            <f7-card-content>
              <f7-icon f7="money_euro_circle_fill"></f7-icon>
            </f7-card-content>
            <f7-card-footer class="bg-color-primary text-color-white">Gastos</f7-card-footer>
          </f7-card>
        </a>
      </f7-row>
      <f7-card v-for="(item,index) in list" :key="'lista-'+index">
        <f7-card-content>
          <!-- <f7-icon f7="gear_alt_fill">{{item.imagen}}</f7-icon> -->
          <i class="f7-icons" :class="'text-color-' + item.color">{{item.imagen}}</i>
          {{item.nombre}}:
          <span :class="'badge color-' + item.color ">{{item.valor}}</span>
        </f7-card-content>
      </f7-card>
    </f7-page-content>

    <!-- Overlay de sincronización: carpeta llenándose de hojas + mensaje en vivo del backend (SSE) -->
    <div v-if="syncing" class="sync-overlay">
      <div class="sync-box">
        <svg class="sync-svg" viewBox="0 0 200 170" xmlns="http://www.w3.org/2000/svg">
          <g class="folder">
            <!-- Cuerpo trasero de la carpeta -->
            <path d="M30 60 h55 l12 14 h63 a8 8 0 0 1 8 8 v60 a8 8 0 0 1 -8 8 H30 a8 8 0 0 1 -8 -8 V68 a8 8 0 0 1 8 -8 z" fill="#E0A72E"/>
            <!-- Hojas que caen dentro de la carpeta -->
            <g class="hoja hoja1">
              <rect x="72" y="30" width="56" height="70" rx="4" fill="#ffffff" stroke="#d8d8d8" stroke-width="1.5"/>
              <line x1="82" y1="46" x2="118" y2="46" stroke="#c9c9c9" stroke-width="3" stroke-linecap="round"/>
              <line x1="82" y1="58" x2="118" y2="58" stroke="#c9c9c9" stroke-width="3" stroke-linecap="round"/>
              <line x1="82" y1="70" x2="106" y2="70" stroke="#c9c9c9" stroke-width="3" stroke-linecap="round"/>
            </g>
            <g class="hoja hoja2">
              <rect x="72" y="30" width="56" height="70" rx="4" fill="#ffffff" stroke="#d8d8d8" stroke-width="1.5"/>
              <line x1="82" y1="46" x2="118" y2="46" stroke="#c9c9c9" stroke-width="3" stroke-linecap="round"/>
              <line x1="82" y1="58" x2="118" y2="58" stroke="#c9c9c9" stroke-width="3" stroke-linecap="round"/>
              <line x1="82" y1="70" x2="112" y2="70" stroke="#c9c9c9" stroke-width="3" stroke-linecap="round"/>
            </g>
            <g class="hoja hoja3">
              <rect x="72" y="30" width="56" height="70" rx="4" fill="#ffffff" stroke="#d8d8d8" stroke-width="1.5"/>
              <line x1="82" y1="46" x2="118" y2="46" stroke="#c9c9c9" stroke-width="3" stroke-linecap="round"/>
              <line x1="82" y1="58" x2="118" y2="58" stroke="#c9c9c9" stroke-width="3" stroke-linecap="round"/>
              <line x1="82" y1="70" x2="108" y2="70" stroke="#c9c9c9" stroke-width="3" stroke-linecap="round"/>
            </g>
            <!-- Panel frontal de la carpeta (delante de las hojas para el efecto de "llenado") -->
            <path d="M22 92 h156 a8 8 0 0 1 8 8 v42 a8 8 0 0 1 -8 8 H22 a8 8 0 0 1 -8 -8 V100 a8 8 0 0 1 8 -8 z" fill="#F2C14E"/>
          </g>
        </svg>
        <div class="sync-msg">{{ syncMensaje }}</div>
        <!-- Una fila por colección con su etapa: el servidor la prepara, la red la baja, la tablet la guarda.
             Son tres cosas distintas que pueden tardar y antes se veía solo la última frase. -->
        <ul v-if="syncResumen" class="sync-lista">
          <li v-for="f in syncResumen.filas" :key="f.clave" class="sync-fila" :class="'sync-fila--' + f.estado">
            <f7-icon :f7="iconoSync(f.estado)" size="14" class="sync-fila-icono"></f7-icon>
            <span class="sync-fila-nombre">{{ f.nombre }}</span>
            <span class="sync-fila-detalle">{{ f.detalle }}</span>
          </li>
        </ul>
        <div v-if="syncResumen" class="sync-contador">{{ syncResumen.hechas }} de {{ syncResumen.total }} guardadas</div>
        <!-- Estado de la red deducido en el sync: corte, lentitud, cambio wifi/datos… -->
        <div v-if="syncRed && syncRed.aviso" class="sync-red" :class="'sync-red--' + syncRed.red">{{ syncRed.aviso }}</div>
        <div v-if="syncRed && syncRed.tipoRedTexto" class="sync-tipo-red" :class="'sync-tipo-red--' + syncRed.tipoRed">
          <f7-icon :f7="syncRed.tipoRed === 'wifi' ? 'wifi' : (syncRed.tipoRed === 'ninguna' ? 'wifi_slash' : 'antenna_radiowaves_left_right')" size="14"></f7-icon>
          {{ syncRed.tipoRedTexto }}
        </div>
      </div>
    </div>
  </f7-page>
</template>
<style scoped>
.badge {
  top: -2px;
}
.card-button .card-content {
  padding-top: 100px;
  overflow: hidden;
}
.card-button .icon {
  position: absolute;
  right: 10px;
  bottom: -10px;
  font-size: 120px;
  transform: rotate(7deg);
}

/* Overlay de sincronización con SSE */
.sync-overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 14000;
}
.sync-box {
  background: #fff;
  border-radius: 16px;
  padding: 22px 24px;
  max-width: 420px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  text-align: center;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
}
/* Lista por colección: etapa en la que está cada una */
.sync-lista {
  list-style: none;
  margin: 12px 0 0;
  padding: 0;
  text-align: left;
}
.sync-fila {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 3px 0;
  font-size: 12px;
  line-height: 1.3;
  color: #333;
}
.sync-fila-icono { flex: 0 0 auto; color: #9e9e9e; }
.sync-fila-nombre { flex: 0 0 auto; min-width: 96px; font-weight: 500; }
.sync-fila-detalle { flex: 1 1 auto; color: #777; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.sync-fila--pendiente { color: #aaa; }
.sync-fila--pendiente .sync-fila-nombre { font-weight: 400; }
.sync-fila--preparando .sync-fila-icono { color: #e0a72e; }
.sync-fila--lista .sync-fila-icono,
.sync-fila--descargando .sync-fila-icono { color: #1976d2; }
.sync-fila--descargando .sync-fila-detalle { color: #1976d2; }
.sync-fila--enCola .sync-fila-icono { color: #9e9e9e; }
.sync-fila--guardando .sync-fila-icono { color: #7b1fa2; }
.sync-fila--guardando .sync-fila-detalle { color: #7b1fa2; }
.sync-fila--hecha .sync-fila-icono { color: #2e7d32; }
.sync-fila--error .sync-fila-icono,
.sync-fila--error .sync-fila-detalle { color: #b00020; }
.sync-contador {
  margin-top: 8px;
  font-size: 12px;
  color: #777;
}
.sync-svg {
  width: 150px;
  height: 130px;
}
.sync-msg {
  margin-top: 14px;
  font-size: 15px;
  color: #333;
  min-height: 20px;
  font-weight: 500;
}
/* Aviso sobre la red: el color dice si es informativo, lentitud o corte */
.sync-red {
  margin-top: 10px;
  padding: 8px 10px;
  border-radius: 8px;
  font-size: 13px;
  line-height: 1.3;
  background: #eef3f8;
  color: #2c3e50;
}
.sync-red--lenta { background: #fff3e0; color: #9a5b00; }
.sync-red--sin-respuesta,
.sync-red--perdida { background: #fdecea; color: #b00020; }
.sync-red--recuperada { background: #e8f5e9; color: #1b5e20; }
.sync-tipo-red {
  margin-top: 10px;
  font-size: 12px;
  color: #777;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.sync-tipo-red--ninguna { color: #b00020; }
.folder {
  animation: folderBob 2.4s ease-in-out infinite;
  transform-origin: center;
}
.hoja {
  animation: hojaCae 2.4s ease-in infinite;
}
.hoja2 { animation-delay: 0.8s; }
.hoja3 { animation-delay: 1.6s; }
@keyframes hojaCae {
  0%   { transform: translateY(-90px); opacity: 0; }
  20%  { opacity: 1; }
  70%  { transform: translateY(0px); opacity: 1; }
  100% { transform: translateY(14px); opacity: 0; }
}
@keyframes folderBob {
  0%, 100% { transform: translateY(0); }
  50%      { transform: translateY(-3px); }
}
</style>
<script>
import rList from "./../components/rList.vue";
import InspeccionOffline from "./../js/db/InspeccionOffline.js";
import DatabaseModelOffline from "./../js/db/DatabaseModelOffline.js";
import Inspeccion from "./../js/db/Inspeccion.js";
import Usuario from "./../js/db/Usuario.js";
import Configuracion from '../js/db/ConfiguracionOffline';
import moment from 'moment';
import Utils from './../js/Utils';
import SincronizacionEvents from './../js/db/SincronizacionEvents.js';
import preloaderDeLaSesion from './../js/utils/preloaderDeLaSesion.js';
import cerrojoDeLaSesion from './../js/utils/cerrojoDeLaSesion.js';

export default {
  components: {},
  data() {
    return {
      list: [],
      config: {},
      Configuracion,
      moment,
      Inspeccion,
      InspeccionOffline,
      DatabaseModelOffline,
      Utils,
      syncing: false,
      syncMensaje: "",
      syncRed: null,
      syncResumen: null
    };
  },
  mounted: function() {
    const self = this;
    const app = self.$f7;
    self._updateConfig();
  },
  beforeDestroy: function() {
    // Cierra el stream SSE de sincronización si se abandona el panel mientras sincroniza.
    if (this._syncHandler) SincronizacionEvents.unsubscribe(this._syncHandler);
    SincronizacionEvents.close();
  },
  methods: {
    _updateConfig() {
      const self = this;
      Configuracion.get({itemId: "CONFIG"})
        .then(result => {
          self.config = result;
        }).catch(_ => self.config = null);
    },
    isSync: function() {
      var self = this;
      return (self.config && self.config.syncDate && self.config.dispositivo && self.moment().diff(self.config.syncDate,'days') < 1);
    },
    limpiarDatos: function() {
      var self = this;
      var app = self.$f7;
      app.dialog.confirm(
        "Se va a realizar la limpieza de datos sincronizados, esto no debería afectar a sus inspecciones editadas o creadas. ¿Desea continuar?",
        "Limpieza de datos sincronizados",
        function() {
          app.preloader.show();
          DatabaseModelOffline.cleanData()
            .then(function() {
              self._updateConfig();
              app.preloader.hide();
              app.dialog.alert("Datos limpiados correctamente", "Confirmación").open();
            })
            .catch(function(e) {
              app.dialog.alert(e.error && e.error.message ? e.error.message : e.error, "Error").open();
            })
            .then(function() {
              app.preloader.hide();
            });
        }
      );
      
    },
    sync: function() {
      var self = this;
      var app = self.$f7;
      // Overlay propio (carpeta llenándose de hojas) + narración SSE del backend, en vez del preloader.
      self.syncMensaje = "Iniciando sincronización…";
      self.syncRed = null;
      self.syncResumen = null;
      // #663 · El cerrojo de la sesión: si la sesión cambia en vuelo, la frontera calla la continuación que lo soltaba.
      cerrojoDeLaSesion(self, 'syncing');
      var cerrarOverlay = function() {
        self.syncing = false;
        self.syncRed = null;
        self.syncResumen = null;
      };
      // Narración del progreso: el sync la va pasando aquí junto con el estado de la red que
      // deduce (corte, lentitud, wifi/datos) y el resumen por colección (preparando en el
      // servidor / descargando / guardando en la tablet). El folder-overlay sigue animándose.
      const narra = function(txt, red, resumen) {
        self.syncMensaje = txt;
        self.syncRed = red || null;
        self.syncResumen = resumen || null;
      };
      app.methods.onTriggerLocalNotification();
      // Modo paquete (el servidor prepara, la tablet descarga por GET con reintento por lote).
      // Si el API aún no lo tiene, streaming (datos por SSE); y si la implementación offline
      // activa no soporta ninguno, el sync() clásico.
      let doSync;
      if (DatabaseModelOffline.syncPaquete) {
        doSync = DatabaseModelOffline.syncPaquete({}, narra).catch(function(e) {
          if (e && e.fallbackStreaming && DatabaseModelOffline.syncStreaming) {
            return DatabaseModelOffline.syncStreaming({}, narra);
          }
          throw e;
        });
      } else if (DatabaseModelOffline.syncStreaming) {
        doSync = DatabaseModelOffline.syncStreaming({}, narra);
      } else {
        doSync = DatabaseModelOffline.sync();
      }
      doSync
        .then(function() {
          cerrarOverlay();
          self._updateConfig();
          app.toast
            .create({
              text: "Datos sincronizados con éxito",
              position: "center",
              closeTimeout: 2000
            })
            .open();
        })
        .catch(function(e) {
          cerrarOverlay();
          console.log(e);
          if (e && e.error == "invalid_token") {
            app.dialog
              .login(
                "Inicia sesión para sincronizar",
                "Token inválido",
                function(username, password) {
                  // #663 · La espera de la sesión: si la sesión cambia en vuelo, la frontera calla el `then` que la apagaba.
                  const espera = preloaderDeLaSesion(self);
                  espera.mostrar();
                  Usuario.auth({ username, password })
                    .then(function(res) {
                      espera.cerrar();
                      app.methods.saveSession({
                        token: res.access_token
                      });
                      app.methods.startSession();
                    })
                    .catch(function(e) {
                      espera.cerrar();
                      app.toast
                        .create({
                          text: e.error_description,
                          position: "center",
                          closeTimeout: 2000
                        })
                        .open();
                    });
                }
              )
              .open();
          } else {
            app.dialog.alert(self._mensajeError(e), "Error").open();
          }
        });
    },
    // Icono de cada etapa de una colección en el diálogo de sincronización.
    iconoSync: function(estado) {
      switch (estado) {
        case 'preparando': return 'gear';
        case 'lista': return 'arrow_down_circle';
        case 'descargando': return 'arrow_down_circle_fill';
        case 'enCola': return 'clock';
        case 'guardando': return 'floppy_disk';
        case 'hecha': return 'checkmark_circle_fill';
        case 'error': return 'xmark_circle_fill';
        default: return 'circle';
      }
    },
    // Extrae un mensaje legible del error del sync, aunque el servidor devuelva HTML (p.ej. 504 del gateway).
    _mensajeError: function(e) {
      if (!e) return "No se pudo sincronizar. Inténtalo de nuevo.";
      if (typeof e === "string") {
        if (/50[24]|gateway\s*time-?out|time-?out/i.test(e)) {
          return "La sincronización ha tardado demasiado y el servidor ha cortado la conexión (tiempo de espera agotado). Inténtalo de nuevo en unos minutos.";
        }
        if (/<\s*html/i.test(e)) return "El servidor ha devuelto un error inesperado. Inténtalo de nuevo.";
        return e;
      }
      if (e.error && e.error.message) return e.error.message;
      if (typeof e.error === "string") return e.error;
      if (e.message) return e.message;
      return "No se pudo sincronizar. Inténtalo de nuevo.";
    },
    descargarExpediente: function () {
      var self = this;
      var app = self.$f7;
      app.dialog.prompt(
        "Introduzca el código del expediente que desea descargar",
        "Descargar expediente",
        function(codigo) {
          Inspeccion.getByCodigo(codigo).then((exp) => {
            console.log(exp)
            var expediente = exp;
            const self = this;
            var params = {};
            params.data = expediente;
            InspeccionOffline.save(params);
            app.dialog.confirm(
                "¿Desea abrir el expediente "+ expediente.codigo + "?",
                function() {
                  app.views.main.router.navigate("/inspecciones/edit-offline/" + expediente.id+"/");
                }
              );
            }).catch(function(e){
              if (typeof e == "string") e = { error: e };
              let error = e.message || e.error || e.error_description;
              app.dialog.alert(error);
              console.log(error);
            });
        }
      );

    }
  }
};
</script>